import {
    createBrowserRouter,
    Navigate,
    useLocation,
} from "react-router-dom"

import { useAuth } from "./contexts/AuthContext"

import Login from "./pages/auth/Login"
import Orders from "./pages/orders/Orders"
import Order from "./pages/order/Order"
import Payments from "./pages/payments/Payments"

import { Forbidden, NotFound } from "./components/error"
import Signup from "./pages/auth/Signup"
import Splash from "./components/splash"
import { OrderProvider } from "./contexts/OrderContext"
import { AudioProvider } from "./contexts/AudioContext"
import Home from "./pages/Home"
import Bot from "./pages/order/Bot"
import Invoice from "./pages/Invoice"
import InvoiceTranscriberDownload from "./pages/InvoiceTranscriberDownload"

const ProtectedRoute = ({ children, admin = false }) => {
    const { session, user, showBot, toggleBot } = useAuth()
    const { pathname } = useLocation()

    if (!session) {
        return <Navigate to="/login" state={{ pathname }} />
    }
    
    if (!user) {
        return <Splash>Chargement du compte</Splash>
    }
    
    if (admin && !user.settings.isAdmin) {
        return <Navigate to="/" state={{ pathname }} />
    }

    return <OrderProvider>
        <AudioProvider>
            {children}

            {showBot && <div className='absolute p-2' style={{ width: 420, height: 'calc(100vh - 64px)', bottom: 0, right: 0 }}>
                <Bot toggleBot={toggleBot} />
            </div>}
        </AudioProvider>
    </OrderProvider>
}


const router = createBrowserRouter([
    {
        path: "/login",
        element: <Login />
    },
    {
        path: "/signup/:token",
        element: <Signup />
    },
    {
        path: "/",
        element: <Navigate to="/payments" />
    },
    {
        path: "/home",
        element: (
            <ProtectedRoute>
                <Home />
            </ProtectedRoute>
        )
    },
    {
        path: "/orders",
        element: (
            <ProtectedRoute>
                <Orders />
            </ProtectedRoute>
        )
    },
    {
        path: "/orders/:id/:page",
        element: (
            <ProtectedRoute>
                <Order />
            </ProtectedRoute>
        )
    },
    {
        path: "/payments",
        element: (
            <ProtectedRoute>
                <Payments />
            </ProtectedRoute>
        )
    },
    {
        path: "/payments/:transcriber_payment_id",
        element: (
            <ProtectedRoute>
                <Payments />
            </ProtectedRoute>
        )
    },
    {
        path: "/invoices/:invoice_id",
        element: (
            <ProtectedRoute admin>
                <Invoice />
            </ProtectedRoute>
        )
    },
    {
        path: "/transcribers/invoices/:invoice_id",
        element: (
            <ProtectedRoute admin>
                <InvoiceTranscriberDownload />
            </ProtectedRoute>
        )
    },
    {
        path: "*",
        element: <ProtectedRoute>
            <NotFound />
        </ProtectedRoute>
    },
])

export default router